module.exports = "<p>\n  base-component works!\n</p>\n"